import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {useLocation, useParams, useNavigate} from "react-router-dom";
import {RequestStatus} from "../../utils/Enums";
import {deleteExtension, getCurrentExtension, resetDeleteExtensionStatus} from "../../store/reducers/ExtensionsSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import {LoggedInView} from "../common/LoggedInView";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link} from "react-router-dom";

interface DeleteExtensionScreenProps {
}

export const DeleteExtensionScreen: React.FC<DeleteExtensionScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const extensionsState = useAppSelector((state) => state.extensions);
    const requestStatus: RequestStatus = extensionsState.deleteExtensionStatus;
    const {id} = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Pikendused", url: "/extensions"},
        {text: "Pikenduse kustutamine", url: `/extensions/${id}/delete`},
    ];

    useEffect(() => {
        dispatch(resetDeleteExtensionStatus());
        if (id) {
            dispatch(getCurrentExtension({id}));
        }
    }, [id, location]);

    const handleConfirm = () => {
        if (id) {
            dispatch(deleteExtension({id}));
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Pikendus kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        return (
            <div className="message" style={{textAlign: "center"}}>
                <div>
                    <h2>
                        Oled kindel, et soovid pikenduse kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes"/>
                            <button type="button" onClick={handleConfirm}>
                <span>
                  <strong>Jah</strong>
                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};